/** @file Sun/moon color-scheme toggle for headers and toolbars. */
import PropTypes from 'prop-types';
import { ActionIcon } from '@mantine/core';
import { IconSun, IconMoon } from '@tabler/icons-react';
import { useThemeMode } from './useThemeMode';

const ThemeToggle = ({ size = 'lg', iconSize = 22 }) => {
  const { isDark, toggle } = useThemeMode();

  return (
    <ActionIcon
      variant="subtle"
      color="coral"
      size={size}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      onClick={toggle}
    >
      {isDark ? <IconSun size={iconSize} /> : <IconMoon size={iconSize} />}
    </ActionIcon>
  );
};

ThemeToggle.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconSize: PropTypes.number
};

export default ThemeToggle;
